import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const marketingDataApi = (id) => `${domain}api/v1/dashboard/marketing-data/${id}`

export const getMarketingData = (id) => interceptor(axios).get(marketingDataApi(id))
export const addMarketingData = (id, data) => interceptor(axios).post(marketingDataApi(id), data)
export const deleteMarketingData = (senderNameId, marketingDataId) => interceptor(axios).delete(marketingDataApi(senderNameId), { data: { id: marketingDataId } })
